export default function ErrorPage() {
  return (
    <>
      <div className="flex h-screen">
        <h1 className="m-auto">Error</h1>
      </div>
    </>
  );
}
